<template>
  <div class="header">
    <div class="top">
      <img src="../../assets/image/mobile/menu-icon.png"
        alt=""
        class="left"
        @click="open=true">
      <img src="../../assets/image/mobile/logo.png"
        alt=""
        class="right">
    </div>
    <div class="menu"
      v-show="open">
      <img src="../../assets/image/mobile/return-icon.png"
        alt=""
        @click="open=false">
      <p :class="active===1?'active':''"
        @click="change('mobile-home',1)">首頁</p>
      <p :class="active===2?'active':''"
        @click="change('mobile-marketing',2)">全面服務</p>
      <p :class="active===3?'active':''"
        @click="change('mobile-brand',3)">商務合作</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 1,
      open: false
    }
  },
  methods: {
    change(name, i) {
      const _name = this.$route.name
      if (name === _name) return
      this.$router.push(name)
      this.active = i
      this.open = false
    }
  },
  created() {
    const name = this.$route.name
    if (name === "mobile-home") {
      this.active = 1
    } else if (name === "mobile-marketing") {
      this.active = 2
    } else if (name === "mobile-brand") {
      this.active = 3
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 28px;
    width: 100%;
    height: 85px;
    background-color: #252531;
    .left {
      width: 26px;
    }
    .right {
      width: 136px;
    }
  }
  .menu {
    position: fixed;
    left: 0;
    top: 0;
    width: 140px;
    height: 667px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 20px 0px rgba(120, 120, 120, 0.86);
    z-index: 99;
    color: #787878;
    text-align: left;
    img {
      width: 25px;
      padding: 35px 0;
      margin-left: 30px;
    }
    p {
      font-size: 18px;
      padding-left: 30px;
      padding-bottom: 25px;
    }
    .active {
      color: #ff3159;
    }
  }
}
</style>